import './i18n'

import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { Suspense } from 'react'
import { hydrate, render } from 'react-dom'
import TagManager from 'react-gtm-module'

import App from './App'
import { Loading } from './components/common'
import { VITE_GTM_IDS } from './constants/config'
import ErrorBoundary from './hoc/ErrorBoundary'

const gtmId = VITE_GTM_IDS?.split(',')[0]
if (gtmId) {
  TagManager.initialize({
    gtmId,
  })
}

dayjs.extend(customParseFormat)

const Root = () => (
  <ErrorBoundary>
    <Suspense fallback={<Loading />}>
      <App />
    </Suspense>
  </ErrorBoundary>
)

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  if (rootElement?.hasChildNodes()) {
    hydrate(<Root />, rootElement)
  } else {
    render(<Root />, rootElement)
  }
}
